import React from 'react';

import { FEmailMessageFragment, useTriggerEmailMessageSendMutation } from '@dashboard/generated/wp/administrator';
import { Button } from '@mui/material';

type Props = {
  emailMessage: FEmailMessageFragment;
};

export default function TriggerSendButton({ emailMessage }: Props) {
  const [trigger, { loading: disabled }] = useTriggerEmailMessageSendMutation();

  const status = emailMessage.status;
  switch (status) {
    case 'DELETED':
    case 'PAUSED':
    case 'SUCCEEDED':
      return null;
  }

  const onClick = () => {
    trigger({ variables: { id: emailMessage.id } });
  };
  return (
    <Button variant="contained" disabled={disabled} onClick={onClick}>
      Send
    </Button>
  );
}
